var content = require("!!../node_modules/css-loader/dist/cjs.js!../node_modules/webfonts-loader/index.js??ref--17-2!../node_modules/eslint-loader/index.js??ref--12-0!./keep-icon.font.js");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
